<template>
  <div>
    <b-alert show variant="info" class="mb-2">
      <feather-icon icon="InfoIcon" class="mr-50" />
      Cole a URL de um post do WordPress para importar seu conteúdo. O WordPress precisa ter a REST API habilitada (padrão desde WP 4.7+).
    </b-alert>

    <b-form-group label="URL do Post WordPress">
      <b-input-group>
        <b-form-input
          v-model="wpUrl"
          placeholder="https://exemplo.com.br/meu-artigo/"
          :disabled="loading"
        />
        <b-input-group-append>
          <b-button variant="primary" :disabled="!wpUrl || loading" @click="importPost">
            <b-spinner v-if="loading" small class="mr-25" />
            <feather-icon v-else icon="DownloadIcon" class="mr-25" />
            Importar
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-alert v-if="error" show variant="danger" dismissible @dismissed="error = ''">
      {{ error }}
    </b-alert>

    <div v-if="imported" class="mt-2">
      <b-alert show variant="success">
        <feather-icon icon="CheckCircleIcon" class="mr-50" />
        Post importado com sucesso! Os campos do editor foram preenchidos.
      </b-alert>
      <div class="border rounded p-2 bg-white">
        <h5>{{ imported.title }}</h5>
        <p class="text-muted">{{ imported.excerpt }}</p>
        <small v-if="imported.featuredImage" class="text-primary">
          <feather-icon icon="ImageIcon" size="12" class="mr-25" />
          Imagem destacada importada
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BAlert, BSpinner } from 'bootstrap-vue'
import axios from '@axios'

export default {
  name: 'WordPressImport',
  components: { BButton, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BAlert, BSpinner },
  data() {
    return {
      wpUrl: '',
      loading: false,
      error: '',
      imported: null,
    }
  },
  methods: {
    async importPost() {
      this.loading = true
      this.error = ''
      this.imported = null
      try {
        const { data } = await axios.post('blog/wordpress-import', { url: this.wpUrl })
        this.imported = data
        this.$emit('imported', data)
      } catch (e) {
        this.error = e.response?.data?.error || 'Erro ao importar post do WordPress'
      }
      this.loading = false
    },
  },
}
</script>
